import React from "react";
import { Table } from "antd";
import { Button, Icon } from "antd";
import { Popconfirm } from "antd";

const { Column } = Table;

const LicenseTable = ({ licenseSet, loading, onDelete, onEdit }) => (
  <Table
    rowKey="id"
    dataSource={licenseSet}
    size="middle"
    pagination={false}
    bordered={false}
    loading={loading}
  >
    <Column
      title="Name"
      dataIndex="name"
      sorter={(a, b) => a.name.localeCompare(b.name)}
    />
    <Column
      title="Action"
      key="action"
      render={(row) => (
        <Button.Group size="small">
          <Button onClick={() => onEdit(row)}>
            <Icon type="edit" />
          </Button>
          <Popconfirm
            onConfirm={() => onDelete(row)}
            title="Do you really want to delete this license?"
            okText="Yes"
            cancelText="No"
            placement="left"
          >
            <Button type="danger">
              <Icon type="delete" />
            </Button>
          </Popconfirm>
        </Button.Group>
      )}
    />
  </Table>
);

export default LicenseTable;
